import React from 'react'

import {
  Beneficiary,
  Contract,
  User,
  ContractTenant,
  UserMetadata,
  FeatureFlag,
} from '../../../common/validations'
import { sortGivenTenantFirst } from '../../utils/sortGivenTenantFirst'
import { useAPIGetUserMetadataSuspense } from '../../api/apiHooks/useAPIGetUserMetadata'
import { useAPIGetFeatureFlags } from '../../api/apiHooks/useAPIGetFeatureFlags'

import { useAPIGetContractSuspense } from 'api/apiHooks/useAPIGetContract'
import { useAPIGetUserProfileSuspense } from 'api/apiHooks/useAPIGetUserProfile'
import { useAPIGetContractBeneficiariesSuspense } from 'api/apiHooks/useAPIGetContractBeneficiaries'
import { useAPIGetContractTenantsSuspense } from 'api/apiHooks/useAPIGetContractTenants'
import { useCurrentContract } from 'hooks/useCurrentContract/useCurrentContract'

interface Data {
  contract: Contract
  user: User
  beneficiaries: Beneficiary[]
  tenants: ContractTenant[] // Note! First is always the user
  userMetadata: UserMetadata
  featureFlags?: FeatureFlag
}

export const DataLoader = ({
  children,
}: {
  children: (data: Data) => React.ReactNode
}) => {
  const { currentContractId } = useCurrentContract()
  const { data: contractData } = useAPIGetContractSuspense(currentContractId)
  const { data: userData } = useAPIGetUserProfileSuspense()
  const { data: beneficiariesData } =
    useAPIGetContractBeneficiariesSuspense(currentContractId)
  const { data: contractTenantsData } =
    useAPIGetContractTenantsSuspense(currentContractId)
  const { data: userMetadata } = useAPIGetUserMetadataSuspense()
  const { data: featureFlags } = useAPIGetFeatureFlags()

  const currentUserName = `${userData.firstName} ${userData.lastName}`

  return children({
    contract: contractData,
    user: userData,
    beneficiaries: beneficiariesData,
    tenants: sortGivenTenantFirst(currentUserName, contractTenantsData),
    userMetadata,
    featureFlags,
  })
}
